export enum LocalStatus {
  Default = 0,
  Unpublished = 60,
  Blocked = 90,
  Deleted = 100
}
